'use client'

import { useEffect, useRef, useState } from 'react'
import Content from './content'
import Registration from './registration'

const options = [
  { name: 'Como funciona', value: 'function' },
  { name: 'Matrícula', value: 'registration' },
]

export default function CourseInformationNavigation() {
  const [activeIndex, setActiveIndex] = useState(0)
  const underlineRef = useRef(null)

  useEffect(() => {
    const buttons = document.querySelectorAll('#buttons li')
    const underline = underlineRef.current

    const updateUnderline = button => {
      underline.style.width = `${button.offsetWidth}px`
      underline.style.left = `${button.offsetLeft}px`
    }

    updateUnderline(buttons[activeIndex])

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        setActiveIndex(index)
        updateUnderline(button)
      })
    })
  }, [activeIndex])

  function handleSelected(index) {
    setActiveIndex(index)
  }

  return (
    <>
      <div id="info">
        <ul className="mt-3 space-y-3 md:hidden">
          {options.map((option, i) => (
            <li key={i}>
              <button
                className="after:-bottom-0.5 relative w-full border-[#877E94] border-b-2 border-opacity-30 text-start font-bold text-[#877E94] text-lg opacity-30 after:absolute after:left-0 after:block after:h-0.5 after:w-0 after:bg-primary-600 after:transition-all after:duration-300 after:ease-out after:content-[''] data-[selected=true]:text-gray-800 data-[selected=true]:opacity-100 data-[selected=true]:after:w-full"
                data-selected={i === activeIndex}
                onClick={() => handleSelected(i)}
                type="button"
                value={option.value}
              >
                {option.name}
              </button>
            </li>
          ))}
        </ul>

        <ul
          className="relative hidden flex-wrap items-center gap-x-10 border-primary-100 border-b-[3px] md:flex"
          id="buttons"
        >
          {options.map((option, index) => (
            <li key={option.name}>
              <button
                className={`py-2 font-medium text-gray-800 text-lg ${activeIndex === index ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
                type="button"
                value={option.value}
              >
                {option.name}
              </button>
            </li>
          ))}
          <div
            className="-bottom-1 absolute h-[3px] rounded-full bg-primary-600 transition-all duration-300"
            ref={underlineRef}
          />
        </ul>
      </div>

      {activeIndex === 0 && <Content />}
      {activeIndex === 1 && <Registration />}
    </>
  )
}
